import LazyLoader from 'Components/LazyLoader';
import { MobXProviderContext, observer } from 'mobx-react';
import React, { useContext } from 'react';
import { RootStoreProps } from 'Stores/RootStore.types';
import { ScrollArea } from '~/lib/ui/scroll-area';
import {
  SidebarContent,
  SidebarHeader,
  SidebarSeparator,
} from '~/lib/ui/sidebar';
import { cn } from '~/lib/utils';
import { EntityProfileActions } from '../EntityProfileActions';
import { GroupDetailsHeader } from './components/GroupDetailsHeader';
import { GroupDetailsMembers } from './components/GroupDetailsMembers';
import { GroupDetailsSidebarProps } from './index.types';

export const GroupDetailsSidebar = observer(
  ({ hidden, closePanel, openContactDetails }: GroupDetailsSidebarProps) => {
    const {
      conversation: { CurrentConversation },
    } = useContext(MobXProviderContext) as RootStoreProps;

    if (!CurrentConversation) {
      return (
        <div className={'flex justify-center items-center h-full'}>
          <LazyLoader delay={0} isLoading />
        </div>
      );
    }

    return (
      <ScrollArea className={cn('h-full pb-3.5', { hidden })}>
        <SidebarHeader>
          <GroupDetailsHeader
            conversation={CurrentConversation}
            closePanel={closePanel}
          />
        </SidebarHeader>
        <SidebarContent>
          <EntityProfileActions conversation={CurrentConversation} />

          <div className="px-3.5">
            <SidebarSeparator />
          </div>

          <GroupDetailsMembers
            conversation={CurrentConversation}
            openContactDetails={openContactDetails}
          />
        </SidebarContent>
      </ScrollArea>
    );
  }
);
